import { defineComponent as _defineComponent } from 'vue'
import { inject, onBeforeUnmount, onMounted, shallowRef, watch } from 'vue'
import { gmapApi } from 'vue2-google-maps'

type Bounds = [number, number, number, number]


export default /*#__PURE__*/_defineComponent({
  __name: 'RasterGroundOverlay',
  props: {
    dataUrl: null,
    bounds: null
  },
  setup(__props: any) {

const props = __props as {
	dataUrl: string | null
	bounds: Bounds | null
};



const mapPromise = inject<Promise<any> | null>('$mapPromise', null)

const google = gmapApi
const mapInstance = shallowRef<any>(null)
let overlay: any = null

const removeOverlay = () => {
	if (overlay) {
		overlay.setMap(null)
		overlay = null
	}
}

const refreshOverlay = () => {
	removeOverlay()

	const map = mapInstance.value
	const g = google()
	if (!map || !g) return
	if (!props.dataUrl || !props.bounds || props.bounds.length !== 4) return

	const [west, south, east, north] = props.bounds
	const latLngBounds = new g.maps.LatLngBounds(
		new g.maps.LatLng(south, west),
		new g.maps.LatLng(north, east),
	)
	overlay = new g.maps.GroundOverlay(props.dataUrl, latLngBounds, { opacity: 0.8 })
	overlay.setMap(map)
}

onMounted(() => {
	if (mapPromise && typeof (mapPromise as any).then === 'function') {
		mapPromise.then((map) => {
			mapInstance.value = map
			refreshOverlay()
		})
	}
})

watch([() => props.dataUrl, () => props.bounds, mapInstance], () => refreshOverlay())

onBeforeUnmount(removeOverlay)

return { __sfc: true,props, mapPromise, google, mapInstance, overlay, removeOverlay, refreshOverlay }
}

})